import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	root: {
		padding: `${theme.spacing ( 2 )}px 0`,
		width: "100%",
		margin: `0 ${theme.spacing ( 2 )}px`
	},
	title: {
		textTransform: "uppercase",
		fontSize: "1rem",
		opacity: 0.5
	},
	body: {
		fontSize: "1.3rem",
		wordBreak: "break-all"
	}
})

class Typeface extends React.Component {

	render () {
		const { classes, variant, weight } = this.props
		return <div className={classes.root} >
			<Typography variant="h6" className={classes.title} >
				{variant} {weight}
			</Typography>
			<div
				className={classes.body}
				style={{ fontFamily: `'${variant}'`, fontWeight: weight }} >
				The quick brown fox jumps over the lazy dog.
			</div>
		</div>
	}

}

Typeface.propTypes = {
	classes: PropTypes.object.isRequired,
	variant: PropTypes.string.isRequired,
	weight: PropTypes.number.isRequired
}

export default withStyles ( styles ) ( Typeface )
